import React from "react";
import { SubSection } from "context/BlogContext";

interface PreviewImageProps {
  subSection: SubSection;
}

const PreviewImage: React.FC<PreviewImageProps> = ({ subSection }) => {
  return (
    <div className="">
      {subSection.type === "image" && (
        <div className="pt-5">
          <div className="">
            {subSection.attrs.src && (
              <div className="flex items-center h-[250px] justify-center">
                <img
                  className="rounded-md h-full w-full object-cover"
                  src={subSection.attrs.src}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewImage;
